import { showToast } from '@/utils/toastMessage/ToastMessage';
import { handleError } from './handleError';

/**
 * global post function
 * @param {*} postFunction
 * @param {*} data
 * @param {*} setLoading
 * @param {*} form
 * @param {function} refresh
 * @returns
 */
const handlePostApi = async (
  postFunction,
  data,
  setLoading,
  form,
  refresh = () => { },
  reset = () => { },
) => {
  try {
    setLoading(true);
    const res = await postFunction(data);
    if (res?.data?.response) {
      showToast(res.data.response, 'success');
      refresh();
      return;
    }
    // showToast('Success', 'success');
  } catch (error) {
    if (error) {
      handleError(error);
      return;
    }

    showToast('Ops something went wrong!', 'error');

    throw new Error(error);
  } finally {
    setLoading(false);
    reset([]);
  }
};

/**
 *
 * @param {*} postFunction
 * @param {*} data
 * @param {*} setLoading
 * @param {*} form
 * @param {*} refresh
 * @returns
 */

const handleUpdatePostApi = async (
  id,
  postFunction,
  data,
  setLoading,
  form,
  refresh = () => { },
  navigate = () => { },
) => {
  try {
    setLoading(true);
    const res = await postFunction(id, data);

    if (res?.data?.response) {
      showToast(res.data.response, 'success');
      form.resetFields();
      refresh();
      navigate();
      return;
    }
    showToast('Success', 'success');
  } catch (error) {
    if (error) {
      handleError(error);
      return;
    }
    showToast('Ops something went wrong!', 'error');

    throw new Error(error);
  } finally {
    setLoading(false);
  }
};

/**
 *
 * @param {*} id
 * @param {*} patchFunction
 * @param {*} data
 * @param {*} setLoading
 */
const handlePatchUpdate = async (
  patchFunction,
  data,
  setLoading,
  refresh = () => { },
) => {
  try {
    setLoading(true);
    const res = await patchFunction(data);
    if (res?.data?.response) {
      showToast(res.data.response, 'success');
      refresh();
      return;
    }
  } catch (error) {
    if (error) {
      handleError(error);
      return;
    }

    showToast('Ops something went wrong!', 'error');

    throw new Error(error);
  } finally {
    setLoading(false);
  }
};

/**
 *
 * @param {*} deleteFunction
 * @param {*} setLoading
 * @param {*} form
 * @param {function} refresh
 */
const handleDeleteApi = async (
  id,
  deleteFunction,
  setLoading,
  refresh = () => { },
) => {
  try {
    setLoading(true);
    const res = await deleteFunction(id);
    if (res?.data?.response) {
      showToast(res.data.response, 'success');
      refresh();
    }
  } catch (error) {
    if (error) {
      handleError(error);
      return;
    }

    showToast('Ops something went wrong!', 'error');

    throw new Error(error);
  } finally {
    setLoading(false);
  }
};

export {
  handlePostApi,
  handleUpdatePostApi,
  handlePatchUpdate,
  handleDeleteApi,
};
